import React, { Component } from 'react';
import injectSheet from 'react-jss';
import _ from 'lodash';

import faker from 'faker';

import {
  Card, CardBody, Input, Media,
} from 'reactstrap';

import Autosuggest from 'react-autosuggest';
import AutosuggestHighlightMatch from 'autosuggest-highlight/match';
import AutosuggestHighlightParse from 'autosuggest-highlight/parse';

const styles = {
  cardContainer: {
    marginRight: '2rem',
    marginBottom: '2rem',
    boxShadow: '0 0.125rem 0.75rem -0.125rem rgba(0, 0, 0, 0.25)',
    borderRadius: '0.3125rem',
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
  },
  card: {
    minWidth: '37.5rem',
    maxWidth: '37.5rem',
    borderRadius: '0.3125rem',
  },
  selectWrapper: {
    // marginBottom: '1rem',
  },
  cardTitle: {
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    marginBottom: '0.3125rem',
  },
  description: {
    fontFamily: ' Lato, Arial',
    fontSize: '0.875rem',
    color: '#656565',
    marginBottom: '0.3125rem',
    lineHeight: '1.313rem',
  },
  leaderInfoWrapper: {
    display: 'flex',
    marginBottom: '1rem',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '3px',
  },
  leaderName: {
    marginLeft: '0.5rem',
    fontFamily: 'Lato, Arial',
    fontSize: '0.875rem',
    color: '#1F1F1F',
    fontWeight: 'bold',
    lineHeight: '1.875rem',
  },
  imageWrapper: {
    width: '2rem',
    height: '2rem',
    display: 'flex',
    position: 'relative',
    overflow: 'hidden',
    fontSize: '1.25rem',
    flexShrink: 0,
    fontFamily: 'Lato',
    alignItems: 'center',
    userSelect: 'none',
    borderRadius: '50%',
    justifyContent: 'center',
  },
  image: {
    width: '100%',
    height: '100%',
    textAlign: 'center',
    objectFit: 'cover',
  },
  chipWrapper: {
    composes: ['chip-wrapper'],
    margin: '0.2rem',
    display: 'flex',
    alignItems: 'center',
    border: '1px solid #E5E7E6',
    borderRadius: '1.5rem',
    padding: '0.1875rem 1rem 0.1875rem 0.1875rem',
    width: 'max-content',
  },
  selectedUserWrapper: {
    display: 'flex',
    flexWrap: 'wrap',
  },
};
const people = [
  {
    id: faker.random.number(1000000000),
    first: faker.name.findName(),
    last: faker.name.findName(),
    img: faker.image.avatar(),
  },
  {
    id: faker.random.number(1000000000),
    first: faker.name.findName(),
    last: faker.name.findName(),
    img: faker.image.avatar(),
  },
  {
    id: faker.random.number(1000000000),
    first: faker.name.findName(),
    last: faker.name.findName(),
    img: faker.image.avatar(),
  },
  {
    id: faker.random.number(1000000000),
    first: 'Cooper',
    last: 'King',
    img: faker.image.avatar(),
  },
];

function escapeRegexCharacters(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function getSuggestionValue(suggestion) {
  return suggestion.displayName; 
}

class AddParticipants extends Component {
  constructor(props) {
    super();

    this.state = {
      value: '',
      suggestions: [],
      selUsers: [...props.participants],
    };
  }

  renderSuggestion = (suggestion, props = {}) => {
    const { query } = props; 
    const suggestionText = `${suggestion.displayName}`;
    const matches = AutosuggestHighlightMatch(suggestionText, query);
    const parts = AutosuggestHighlightParse(suggestionText, matches);

    return (
      <span className="suggestion-content" onClick={this.toggleUserExistence(suggestion)}>
        <div className="imageWrapper">
          <Media
            src={suggestion.image}
            className="image"
            alt="Generic placeholder image"
          />
        </div>
        <span className="name">
          { 
            parts.map((part, index) => {
              const className = part.highlight ? 'highlight' : null;

              return (
                <span className={className} key={index}>{part.text}</span>
              );
            })
          }
        </span>
        <i className="icon-cross" onClick={this.removeSelectedUser(suggestion)} />
      </span>
    );
  }

  getSuggestions = (value) => {
    const escapedValue = escapeRegexCharacters(value.trim());
  
    if (escapedValue === '') {
      return [];
    }
  
    const regex = new RegExp('\\b' + escapedValue, 'i');
  
    return this.props.users
      .filter(person => regex.test(person.displayName))
      .filter(person => _.map(this.state.selUsers, '_id').indexOf(person._id) < 0 )
  }

  toggleUserExistence = (suggestion) => (e) => {
    if (_.some(this.state.selUsers, {_id: suggestion._id})) {
      return this.removeSelectedUser(suggestion)(e);
    } else {
      return this.selectedUser(suggestion)(e);
    }
  }

  removeSelectedUser = (suggestion) => (e) => {
    this.setState({
      selUsers: _.filter(this.state.selUsers, (u) => u._id !== suggestion._id )
    })

    if (this.props.onRemoveParticipant) {
      this.props.onRemoveParticipant(suggestion);
    }
  }

  selectedUser = (suggestion) => (e) => { 
    this.setState({
      selUsers: [...this.state.selUsers, suggestion],
    });

    if (this.props.onAddParticipant) {
      this.props.onAddParticipant(suggestion);
    }

  }

  onChange = (event, { newValue, method }) => {
    this.setState({
      value: newValue,
    });
  };

  onSuggestionsFetchRequested = ({ value }) => {
    this.setState({
      suggestions: this.getSuggestions(value),
    });
  };

  onSuggestionsClearRequested = () => {
    this.setState({
      suggestions: [],
    });
  };

  render() {
    const { classes, leaderImage, leaderName } = this.props;
    const { value, suggestions, selUsers } = this.state;
    const inputProps = {
      placeholder: 'Add a participant...',
      value,
      onChange: this.onChange,
    };
    
    return (
      <div className={classes.cardContainer}>
        <Card className={classes.card}>
          <CardBody>
            <div className={classes.cardTitle}>
             Jam Leader(s):
            </div>
            <div className={classes.description}>
              Responsible for conducting the Jam, then posting as final fruit.
            </div>
            <div className={classes.leaderInfoWrapper}>
              <div className={classes.imageWrapper}>
                <Media
                  src={leaderImage || require(`../assets/userDefaultImage.png`)}
                  className={classes.image}
                  alt="Generic placeholder image"
                />
              </div>
              <div className={classes.leaderName}>
                {leaderName}
              </div>
            </div>
            <div className={classes.cardTitle}>
              Participant(s):
            </div>
            <div className={classes.description}>
              Add people who will participate in this Jam. Participant will receive an email with link to view the jam live.
            </div>
            <div className={classes.selectWrapper}>
              <Autosuggest
                suggestions={suggestions}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                getSuggestionValue={getSuggestionValue}
                renderSuggestion={this.renderSuggestion}
                inputProps={inputProps}
              />
            </div>
            <div className={classes.selectedUserWrapper}>
              {selUsers.length > 0 ?
                selUsers.map((selected, index) => {
                  return (
                    <div className={classes.chipWrapper} key={index} >
                      {this.renderSuggestion(selected)}
                    </div>
                  )
                  // return (
                  //   <div className={classes.chipWrapper} key={index} dangerouslySetInnerHTML={{__html: selected}} />
                  // );
                })
                : ''
              }
            </div>
          </CardBody>
        </Card>
      </div>
    );
  }
}

export default injectSheet(styles)(AddParticipants);



// WEBPACK FOOTER //
// ./src/components/AddParticipants.js